import React from 'react';
import { Pagination as PaginationComponent, PaginationItem, PaginationLink } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Browser } from '@syncfusion/ej2-base';

import { colors } from 'shared/defaultTheme';

const Pagination = ({
  currentPage,
  lastPage,
  totalData,
  onFirstPage,
  onLastPage,
  onPreviousPage,
  onNextPage,
  onGoToPage,
  titlePagination,
}) => {
  const { t } = useTranslation();
  const PageNumberItems = () => {
    if (lastPage <= 1) {
      return (
        <PaginationItem>
          <PaginationLink onClick={() => onGoToPage(1)}>1</PaginationLink>
        </PaginationItem>
      );
    }
    if (currentPage < 3) {
      return (
        <>
          <PaginationItem>
            <PaginationLink onClick={() => onGoToPage(1)}>1</PaginationLink>
          </PaginationItem>
          {Array.from(Array(lastPage > 2 ? 2 : 1).keys()).map((value) => (
            <React.Fragment key={value}>
              <PaginationItem>
                <PaginationLink onClick={() => onGoToPage(value + 2)}>{value + 2}</PaginationLink>
              </PaginationItem>
            </React.Fragment>
          ))}
        </>
      );
    }
    if (currentPage === lastPage) {
      return (
        <>
          <PaginationItem>
            <PaginationLink onClick={() => onGoToPage(1)}>1</PaginationLink>
          </PaginationItem>
          <PaginationItem>
            <span>...</span>
          </PaginationItem>
          {Array.from(Array(3).keys())
            .reverse()
            .map((value) => (
              <React.Fragment key={value}>
                <PaginationItem>
                  <PaginationLink onClick={() => onGoToPage(currentPage - value)}>
                    {currentPage - value}
                  </PaginationLink>
                </PaginationItem>
              </React.Fragment>
            ))}
        </>
      );
    }

    return (
      <>
        <PaginationItem>
          <PaginationLink onClick={() => onGoToPage(1)}>1</PaginationLink>
        </PaginationItem>
        {currentPage - 1 > 2 && (
          <PaginationItem>
            <span>...</span>
          </PaginationItem>
        )}
        <PaginationItem>
          <PaginationLink onClick={() => onGoToPage(currentPage - 1)}>
            {currentPage - 1}
          </PaginationLink>
        </PaginationItem>
        <PaginationItem>
          <PaginationLink onClick={() => onGoToPage(currentPage)}>{currentPage}</PaginationLink>
        </PaginationItem>
        <PaginationItem>
          <PaginationLink onClick={() => onGoToPage(currentPage + 1)}>
            {currentPage + 1}
          </PaginationLink>
        </PaginationItem>
      </>
    );
  };

  return (
    <>
      <hr className="panel-control__hr" />
      <div className="d-flex">
        <PaginationComponent aria-label="Page navigation clients">
          <PaginationItem className="control-panel__boder-pagination-all pagination--hover">
            <PaginationLink first onClick={onFirstPage} type="button" />
          </PaginationItem>
          <PaginationItem className="control-panel__boder-pagination pagination--hover">
            <PaginationLink previous onClick={onPreviousPage} type="button" />
          </PaginationItem>
          <PageNumberItems />
          <PaginationItem className="control-panel__boder-pagination pagination--hover">
            <PaginationLink next onClick={onNextPage} type="button" />
          </PaginationItem>
          <PaginationItem className="control-panel__boder-pagination-all pagination--hover">
            <PaginationLink last onClick={onLastPage} type="button" />
          </PaginationItem>
        </PaginationComponent>
        {!Browser.isDevice && (
          <span style={{ color: colors.suvaGrey }} className="ml-2">
            {`${currentPage} 
          ${t('general_pagination_of')} ${lastPage} 
          ${t('general_pagination_pages')} (${totalData} 
          ${titlePagination})`}
          </span>
        )}
      </div>
    </>
  );
};

Pagination.defaultProps = {
  currentPage: 0,
  lastPage: 0,
  totalData: 0,
  onFirstPage: () => {},
  onLastPage: () => {},
  onPreviousPage: () => {},
  onNextPage: () => {},
  onGoToPage: () => {},
};

Pagination.propTypes = {
  currentPage: PropTypes.number,
  lastPage: PropTypes.number,
  totalData: PropTypes.number,
  onFirstPage: PropTypes.func,
  onLastPage: PropTypes.func,
  onPreviousPage: PropTypes.func,
  onNextPage: PropTypes.func,
  onGoToPage: PropTypes.func,
  titlePagination: PropTypes.string.isRequired,
};

export default Pagination;
